import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState} from "../AppState";
import {catchError, map, mergeMap, switchMap} from "rxjs/operators";
import {fromFetch} from "rxjs/fetch";
import ApiUrl from "../api/ApiUrl";
import {
    USER_LOGIN,
    WorkforceOneLoggedInWrongUrl,
    WorkforceOneLoginAction,
    WorkforceOneUserHasLoggedIn,
    WorkforceOneUserLoginFailed
} from "../actions/WorkforceOneLoginActions";

const WorkforceOneUserLoginEpic:  Epic<AppActions, AppActions, AppState> = (action$, state$ ) => {
    return action$.pipe(
        ofType(USER_LOGIN),
        mergeMap((action:AppActions) => {
                const loginDetailFromAction = action as WorkforceOneLoginAction;
                return fromFetch(`${ApiUrl()}FFOrderAccount/Login`,
                    {
                        method: 'POST',
                        credentials: 'omit',
                        body: JSON.stringify(loginDetailFromAction.payload),
                        headers: {
                            'IsMarketPlace':"true",
                            'Agent': 'Chrome',
                            'api_version':'1.0',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                    })
                    .pipe(switchMap(response => response.ok ?
                        response.json() : Promise.resolve(response.json())),
                        catchError(err => {
                            console.error(err);
                            return Promise.resolve(null);
                        })
                        )
                    .pipe(map(json => json != null && (json.data != null || json.error != null)
                        ? json.error != null
                          ? WorkforceOneUserLoginFailed(json.error.message)
                          : json.data.Message != null
                            ? WorkforceOneLoggedInWrongUrl(json.data)
                            : WorkforceOneUserHasLoggedIn(json.data.AuthToken, json.data.UserLoginID, "", json.data)
                        : WorkforceOneUserLoginFailed()))
            }
        )
    );
};
export default WorkforceOneUserLoginEpic;
